<div class="row">
  <div class=" col-sm-11 col-xl-10">
  <div class="row">
    <div class=" col-sm-12 col-lg-6">
    <div class="row">
      <div class="section-name col-sm-6 col-lg-12">
      {{topic.displayName}}
      </div>
      <div class="topic-data col-sm-6 col-lg-12">
        <div class="sub-info"><strong>CREATED BY: </strong>{{topic.author?.name | uppercase}}</div>
        <div class="sub-info"><strong>LAST UPDATED: </strong>{{topic.updateDate || topic.createdTime | date : 'mediumDate' | uppercase}}</div>
        <div class="sub-info"><strong>{{topic.files.length + (topic.files.length > 1 ? " DOCUMENTS" : " DOCUMENT")}} </strong></div>
      </div>
    </div>
    </div>
    <div class="topic-desc col-sm-11 col-lg-6">
    {{topic.description}}
    </div>
  </div>
  </div>

  <div class="col-sm-1 offset-xl-1">
      <app-asset-action
        [asset]="topic"
        [type]="'viewer'"
        (download)="download($event)"
        class="file-action">
    </app-asset-action>
  </div>
</div>


